<div class="my-7">
  <mat-form-field class="moneytor-input" [ngClass]="class">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      [type]="type"
      [name]="placeholder"
      [placeholder]="placeholder"
      [required]="required"
      [pattern]="pattern"
      [(ngModel)]="model"
      [disabled]="disabled"
      (ngModelChange)="onModelChange($event)"
      #inputData="ngModel"
      />
    @if (inputType === 'password') {
      <mt-btn
        matSuffix
        [class]="hide ? 'icon' : 'icon warning'"
        (onAction)="showHidePass($event)"
        >
        <mat-icon class="mt-icon-size">{{
          hide ? "visibility" : "visibility_off"
        }}</mat-icon>
      </mt-btn>
    }
    @if (iconPlace == 'post') {
      <mt-btn matSuffix class="icon">
        <mat-icon class="mt-icon-size">{{ icon }}</mat-icon>
      </mt-btn>
      } @if (iconPlace == 'pre') {
      <mt-btn matPrefix class="icon">
        <mat-icon class="mt-icon-size">{{ icon }}</mat-icon>
      </mt-btn>
      } @if (inputData.invalid && inputData.touched &&
      inputData.hasError('required')) {
      <mat-error>This field is required*</mat-error>
      } @if (inputData.invalid && inputData.touched &&
      inputData.hasError('pattern')) {
      <mat-error>Please enter valid {{ label ? label : "field" }}</mat-error>
    }
  </mat-form-field>
</div>
